import { EVENTS_TOGGLE_EVENT_UPDATE } from './constants';

export function toggleEventUpdate() {
  return {
    type: EVENTS_TOGGLE_EVENT_UPDATE,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case EVENTS_TOGGLE_EVENT_UPDATE:
      return {
        ...state,
        isOpenEventUpdateModel: !state.isOpenEventUpdateModel,
      };

    default:
      return state;
  }
}
